export const DOCKERFILE_SOURCE_PLACEHOLDER = `FROM node:18-alpine

WORKDIR /app
COPY . .
RUN yarn install --production`

export const DOCKERFILE_PATH_PLACEHOLDER = './Dockerfile'
export const DOCKERFILE_SOURCE_RADIO_NAME = 'Describe  in command line'
export const DOCKERFILE_PATH_RADIO_NAME = 'Specify the path and Dockerfile name'
